import { Box, BoxProps as IBoxProps, styled } from "@mui/material";

export const LandingPageWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(({ theme }) => ({
  "&.landing-page-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: "2rem",
    height: "70%",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem",
      height: "415px",
    },
    [theme.breakpoints.between("sm", "xl")]: {
      height: "60%",
    },
    ".landing-page": {
      width: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "1.5rem",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "70%",
      },
      ".heading": {
        fontWeight: 700,
        color: "#1a0d2e",
        textAlign: "center",
        "@media (min-width: 375px) and (max-width: 425px)": {
          fontSize: "1.5rem",
        },
        "@media (min-width: 320px) and (max-width: 375px)": {
          fontSize: "1.5rem",
        },
        "@media (min-width: 0px) and (max-width: 320px)": {
          fontSize: "1.37rem",
        },
        [theme.breakpoints.between("sm", "xl")]: {
          fontSize: "2.125rem",
        },
        [theme.breakpoints.up("xl")]: {
          fontSize: "3rem",
        },
      },
      ".text": {
        textAlign: "center",
        fontSize: "1.1rem",
        [theme.breakpoints.down("sm")]: {
          fontSize: "1rem",
          lineHeight: 1.6,
        },
        [theme.breakpoints.up("xl")]: {
          fontSize: "1.5rem",
        },
      },
    },
  },
}));
